module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-moving-history\" style=\"position: absolute; z-index:10;\">\n	<div class=\"gl-map-panel\">\n		<div class=\"header\">\n			<div class=\"split__right icons\">\n				<div class=\"icon-16 icon-close gl-pointer\" title=\"Закрыть\" on-click=\"onCloseClick\"></div>\n			</div>\n		</div>\n\n		<div name=\"params\"></div>\n\n		<div class=\"row\">\n			<label><input type=\"checkbox\" name=\"follow-toggler\" on-click=\"onFollowClick\"/>&nbsp;слежение</label>\n		</div>\n\n		<div name=\"options\"></div>\n\n		<div name=\"route-segments\"></div>\n\n		<div class=\"row\">\n			Скорость:&nbsp;\n			<label><input type=\"radio\" name=\"speed\" value=\"0.25\" on-click=\"onChangeSpeedClick\"/>0.5x</label>\n			<label><input type=\"radio\" name=\"speed\" value=\"1\" on-click=\"onChangeSpeedClick\"checked=\"checked\"/>1x</label>\n			<label><input type=\"radio\" name=\"speed\" value=\"4\" on-click=\"onChangeSpeedClick\"/>2x</label>\n			<label><input type=\"radio\" name=\"speed\" value=\"8\" on-click=\"onChangeSpeedClick\"/>4x</label>\n		</div>\n\n		<div class=\"row slider-container\">\n			<div name=\"rewind\"></div>\n		</div>\n\n		<div name=\"buttons\" class=\"row\" style=\"margin-bottom: 0px\"></div>\n	</div>\n\n	<div name=\"statistics-panel\" style=\"margin-top: 10px;\"></div>\n</div>\n\n<style>\n	.gl-moving-history {\n		width: 400px;\n	}\n\n	.gl-moving-history .header {\n		height: 12px;\n	}\n\n	.gl-moving-history .header .icons > div {\n		margin-left: 10px;\n	}\n\n	.gl-moving-history .row {\n		margin-bottom: 5px;;\n	}\n</style>")
  }
  return __output.join("");

}